import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Link from "../components/Link";
import Dashboard from "../components/Dashboard";
import Loader from "../components/Loader";
import { ProtectedRoute, PublicOnlyRoute } from "./RouteGuards";
import { ROUTE_PATHS } from "./paths";

type AppRoutesProps = {
  accessToken: string | null;
  linkToken: string | null;
};

const LoadingScreen = () => (
  <Loader text="Preparing secure connection" fullScreen />
);

const AppRoutes = ({ accessToken, linkToken }: AppRoutesProps) => (
  <Routes>
    <Route
      path={ROUTE_PATHS.CONNECT}
      element={
        <PublicOnlyRoute isAuthenticated={Boolean(accessToken)}>
          {linkToken ? <Link /> : <LoadingScreen />}
        </PublicOnlyRoute>
      }
    />

    <Route
      path={ROUTE_PATHS.DASHBOARD}
      element={
        <ProtectedRoute isAuthenticated={Boolean(accessToken)}>
          <Dashboard />
        </ProtectedRoute>
      }
    />

    <Route
      path={ROUTE_PATHS.ROOT}
      element={<Navigate to={ROUTE_PATHS.CONNECT} replace />}
    />

    <Route
      path="*"
      element={<Navigate to={ROUTE_PATHS.CONNECT} replace />}
    />
  </Routes>
);

export default AppRoutes;
